import Menu from '@mui/material/Menu';

import { IMenuElementsProps } from './menuElementProps';

export const MenuElements = (props: IMenuElementsProps) => {
  const {
    anchorEl,
    anchorOrigin,
    children,
    className,
    id,
    MenuListProps,
    onClose,
    onClick,
    open,
    PaperProps,
    transformOrigin,
  } = props;

  if (children) {
    return (
      <Menu
        className={className}
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        autoFocus={false}
        disableAutoFocus
        disableEnforceFocus
        hideBackdrop
        onClose={onClose}
        onClick={onClick}
        slotProps={{
          paper: { ...PaperProps },

          list: {
            ...MenuListProps,
          },
        }}
      >
        {children}
      </Menu>
    );
  }

  return null;
};
